


import React from 'react';

export const About = () => {
  const version = process.env.REACT_APP_VERSION || 'development';
  return <h1>Version: {version}</h1>;
};
